import { Button, Logo, PageHeading } from '@aulaviva/ui';
import { useNavigate } from 'react-router';
import { nonTrovata } from '@/testi';

export function NonTrovata() {
  const navigate = useNavigate();
  return (
    <main className="min-h-dvh contenitore flex flex-col items-center justify-center gap-8 text-center">
      <Logo variant="marchio" height={64} className="dark:hidden" />
      <Logo variant="marchio-negativo" height={64} className="hidden dark:block" decorative />
      <PageHeading subtitle={nonTrovata.testo}>{nonTrovata.titolo}</PageHeading>
      <Button variant="primary" onClick={() => navigate('/')}>
        {nonTrovata.azione}
      </Button>
    </main>
  );
}
